const MONTH = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

/** "2026-09-21" (a Monday week_start) -> "21–27 Sep" (UX-mockup prototype v2 week picker). */
export function formatWeekRange(weekStart: string): string {
  const start = new Date(`${weekStart}T00:00:00Z`);
  if (Number.isNaN(start.getTime())) return weekStart;
  const end = new Date(start);
  end.setUTCDate(end.getUTCDate() + 6);
  const sameMonth = start.getUTCMonth() === end.getUTCMonth();
  const startPart = `${start.getUTCDate()}`;
  const endPart = sameMonth
    ? `${end.getUTCDate()} ${MONTH[end.getUTCMonth()]}`
    : `${end.getUTCDate()} ${MONTH[end.getUTCMonth()]}`;
  const startLabel = sameMonth ? startPart : `${startPart} ${MONTH[start.getUTCMonth()]}`;
  return `${startLabel}–${endPart}`;
}
